import React, { useEffect, useRef, useState } from 'react';
import { Chart } from 'chart.js';

const Charts = ({ data }) => {
  console.log('5555555555555', data);
  const canvasRef = useRef(null);
  const [chartData, setChartData] = useState({
    energySavedCount: 0, // Renamed to match the property used in data update
    adoptHealthyLifestylesCount: 0,
    adoptSustainableFoodSystemsCount: 0,
    reduceEWasteCount: 0,
    reduceWasteCount: 0,
    saveWaterCount: 0,
    sayNoToSingleUsePlasticCount: 0,
  });

  const options = {
    type: 'line',
    data: {
      labels: [
        '',
        'Adopt Healthy Lifestyles',
        'Adopt Sustainable Food Systems',
        'Reduce E-Waste',
        'Reduce Waste',
        'Save Energy',
        'Save Water',
        'Say No to Single Use Plastic',
      ],
      datasets: [
        {
          label: 'Current Year',
          fill: false,
          lineTension: 0.4,
          pointBorderWidth: 2,
          borderColor: "#4caf50",
          data: [], // Initial empty data
        },
      ],
    },
  };

  useEffect(() => {
    const updatedChartData = {
      adoptHealthyLifestylesCount: 0,
      adoptSustainableFoodSystemsCount: 0,
      reduceEWasteCount: 0,
      reduceWasteCount: 0,
      energySavedCount: 0,
      saveWaterCount: 0,
      sayNoToSingleUsePlasticCount: 0,
    };

    data && data?.forEach(item => {
      switch (item.theme_name) {
        case 'Adopt Healthy Lifestyles':
          updatedChartData.adoptHealthyLifestylesCount = item.collaborationCount;
          break;
        case 'Adopt sustainable food systems':
          updatedChartData.adoptSustainableFoodSystemsCount = item.collaborationCount;
          break;
        case 'Reduce E-Waste':
          updatedChartData.reduceEWasteCount = item.collaborationCount;
          break;
        case 'Reduce Waste':
          updatedChartData.reduceWasteCount = item.collaborationCount;
          break;
        case 'Save Energy':
          updatedChartData.energySavedCount = item.collaborationCount;
          break;
        case 'Save Water':
          updatedChartData.saveWaterCount = item.collaborationCount;
          break;
        case 'Say No to Single Use Plastic':
          updatedChartData.sayNoToSingleUsePlasticCount = item.collaborationCount;
          break;
        default:
          break;
      }
    });

    setChartData(updatedChartData);
  }, [data]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Initialize the chart
    const chart = new Chart(ctx, {
      ...options,
      data: {
        ...options.data,
        datasets: [
          {
            ...options.data.datasets[0],
            data: [
              '',
              chartData.adoptHealthyLifestylesCount,
              chartData.adoptSustainableFoodSystemsCount,
              chartData.reduceEWasteCount,
              chartData.reduceWasteCount,
              chartData.energySavedCount,
              chartData.saveWaterCount,
              chartData.sayNoToSingleUsePlasticCount,
            ],
          },
        ],
      },
    });

    // Cleanup the chart instance when the component unmounts
    return () => {
      chart.destroy();
    };
  }, [chartData]); // Run whenever chartData changes

  return (
    <div>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default Charts;
